/**
 * MuiBadge
 */
const MuiBadge = {
  styleOverrides: {
    badge: {
      top: -3
    },
    dot: {
      outline: '2px solid white',
      minWidth: 6,
      width: 6,
      height: 6,
      top: 2,
      right: 2
    }
  }
};
export default MuiBadge;